export default "__VITE_ASSET__BsO6Jo8W__"